export enum CustomerKycStatus {
  NotSubmitted = 0,
  Submitted = 1,
  Verified = 2,
  Rejected = 3,
}

export enum UserCouponStatus {
  Unused = 0,
  Redeemed = 1,
}

export interface CustomerKycDto {
  fullName: string;
  aadhaarNumber: string;
  panNumber: string;
  bankAccountName: string;
  bankAccountNumber: string;
  bankIfsc: string;
  bankName: string;
}

export interface CustomerMemberProfileDto {
  userId: string;
  memberCode?: string;
  isMemberActive: boolean;
  isPrimeMember: boolean;
  memberActivatedAt?: string;
  personalBv: number;
  activationBvThreshold: number;
  kycStatus: CustomerKycStatus;
  kycStatusText: string;
  kycVerified: boolean;
  kycSubmitted: boolean;
  kycSubmittedAt?: string;
  kycVerifiedAt?: string;
  kycRejectionReason?: string;
  kycDetails?: CustomerKycDto;
  unusedCouponCount: number;
}

export interface UserCouponDto {
  id: number;
  code: string;
  discountValue: number;
  status: UserCouponStatus;
  statusText: string;
  issuedAt: string;
  redeemedAt?: string;
}

export interface WalletTransferDto {
  toMemberCode: string;
  amount: number;
  note?: string;
}

export interface VerifyCustomerKycDto {
  approve: boolean;
  rejectionReason?: string;
}
